<template>
	<div>
		<div v-if="keyboard">
			<div class="clearfix keyboard">
				<button type="button" class="btn btn-outline-dark m-1" v-for="(item, index) in random"
				        @click="setNum(index)" :disabled="lock">
					{{item}}
				</button><button type="button" class="btn btn-outline-dark m-1" @click="backspace" :disabled="lock">
					<i class="fa fa-arrow-left"></i>
				</button><button type="button" class="btn btn-outline-dark m-1" @click="reload" :disabled="lock">
					<i class="fa fa-sync"></i>
				</button>
			</div>
		</div>
		<input type="hidden" v-model="localValue" :id="id" :name="name"/>
		<input v-model.trim="password"
		       class="form-control"
		       type="text"
		       autocomplete="off"
		       @input="maskInput(false)"
			   :placeholder="placeholder"
		       :class="className"
		       :readonly="keyboard"
		>
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: "password-group",
		props: ['placeholder', 'id', 'name', 'className', 'maskSymbol', 'reset', 'keyboard', 'lock'],
		data() {
			return {
				password: '',
				_realField: '',
				localValue: '',
				symbol: '\u25CF',
				random: []
			}
		},
		mounted() {
			if(this.$props.maskSymbol) {
				this.symbol = this.$props.maskSymbol;
			}
			setInterval(() => this.maskInput(true), 500);

			if(this.$props.keyboard) {
				this.loadKeyboard();
			}
		},
		watch: {
			localValue() {
				this.$emit('input', this.localValue)
			},
			reset() {
				this.password = '';
				this._realField = '';
				this.localValue = '';
				if(this.$props.keyboard) {
					this.loadKeyboard();
				}
			}
		},
		methods: {
			maskInput(fullMask) {
				let plainPassword = '';
				for (var i = 0; i < this.password.length; i++) {
					if (this.password.charAt(i) == this.symbol) {
						plainPassword += this._realField.charAt(i);
					} else {
						plainPassword += this.password.charAt(i);
					}
				}

				let maskedString = this.encodeMaskedPassword(plainPassword, fullMask);

				if(this._realField != plainPassword || this.password != maskedString)
				{
					this._realField = plainPassword;
					this.localValue = this._realField;
					this.password = maskedString;
				}
			},
			encodeMaskedPassword(passwordString, fullMask) {
				var characterLimit = fullMask === true ? 0 : 1;

				for(var maskedString = '', i=0; i<passwordString.length; i++)
				{
					if(i < passwordString.length - characterLimit) {
						maskedString += this.symbol;
					} else {
						maskedString += passwordString.charAt(i);
					}
				}

				return maskedString;
			},
			loadKeyboard() {
				var tabVal = Array.from(new Array(10),(val,index)=>index);

				for(var i = tabVal.length; i < 18; i ++) {
					tabVal[i] = '';
				}
				this.random = this.shuffle(tabVal);
			},
			setNum(num) {
				this.password += this.random[num];
			},
			backspace() {
				if(this.password.length) {
					this.password = this.password.slice(0, -1);
				}
			},
			reload() {
				this.loadKeyboard();
				this.password = '';
			},
			shuffle(array) {
				var currentIndex = array.length, temporaryValue, randomIndex;

				// While there remain elements to shuffle...
				while (0 !== currentIndex) {

					// Pick a remaining element...
					randomIndex = Math.floor(Math.random() * currentIndex);
					currentIndex -= 1;

					// And swap it with the current element.
					temporaryValue = array[currentIndex];
					array[currentIndex] = array[randomIndex];
					array[randomIndex] = temporaryValue;
				}
				return array;
			}
		}
	}
</script>

<style scoped>
.keyboard > .btn {
	font-weight: 300;
	font-size: 12px;
	min-width: 8.28%;
	border-radius: 4px;
	height: 30px;
	font-weight: bold;
	padding: 0;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/password-group.vue